// // useSessionRefresh.js
// import { useEffect } from "react";
// import Cookies from "js-cookie";

// // Refresh the token expiration on user activity (10 min)
// export const useSessionRefresh = () => {
//   const refreshTokenExpiration = () => {
//     const expirationTime = new Date(new Date().getTime() + 10 * 60 * 1000); // 10 min
//     const userDetails = Cookies.get("user_details");
//     if (userDetails) {
//       Cookies.set("user_details", Cookies.get("user_details"), {
//         expires: expirationTime,
//       });
//     }
//   };

//   useEffect(() => {
//     window.addEventListener("mousemove", refreshTokenExpiration);
//     window.addEventListener("keydown", refreshTokenExpiration);

//     return () => {
//       window.removeEventListener("mousemove", refreshTokenExpiration);
//       window.removeEventListener("keydown", refreshTokenExpiration);
//     };
//   }, []);
// };

// useSessionRefresh.js
import { useEffect } from "react";
import Cookies from "js-cookie";

const SESSION_DURATION_MS = 10 * 60 * 1000; // 10 minutes

// Refresh ALL cookie expiration times on user activity.
// This creates a sliding session — the user stays logged in as long as
// they keep interacting. If they go idle for 10 minutes, all cookies
// expire and the next API call will redirect them to /login.
export const useSessionRefresh = () => {
  const refreshTokenExpiration = () => {
    const expirationTime = new Date(Date.now() + SESSION_DURATION_MS);

    const userDetails = Cookies.get("user_details");
    const authToken = Cookies.get("AUTH_TOKEN");
    const refreshToken = Cookies.get("REFRESH_TOKEN");

    // Only refresh if the cookie still exists (i.e. session hasn't expired yet)
    if (userDetails) {
      Cookies.set("user_details", userDetails, { expires: expirationTime });
    }
    if (authToken) {
      Cookies.set("AUTH_TOKEN", authToken, { expires: expirationTime });
    }
    if (refreshToken) {
      Cookies.set("REFRESH_TOKEN", refreshToken, { expires: expirationTime });
    }
  };

  useEffect(() => {
    // Throttle the refresh — no need to update cookies on every single
    // mousemove event (fires hundreds of times per second). Once every
    // 60 seconds is more than enough.
    let lastRefresh = 0;

    const throttledRefresh = () => {
      const now = Date.now();
      if (now - lastRefresh > 60 * 1000) {
        lastRefresh = now;
        refreshTokenExpiration();
      }
    };

    window.addEventListener("mousemove", throttledRefresh);
    window.addEventListener("keydown", throttledRefresh);
    window.addEventListener("click", throttledRefresh);
    window.addEventListener("scroll", throttledRefresh);

    return () => {
      window.removeEventListener("mousemove", throttledRefresh);
      window.removeEventListener("keydown", throttledRefresh);
      window.removeEventListener("click", throttledRefresh);
      window.removeEventListener("scroll", throttledRefresh);
    };
  }, []);
};